import { useEffect } from 'react';
import { useParams } from 'react-router';
import EstadoForm from '../../components/estados/EstadoForm';
import { useEstadosStore, type ActualizarEstado } from '../../stores/estados/estados.store';

const EditarEstado = () => {
  const paramId = useParams<{ id: string }>().id ?? '';
  const id = Number(paramId);
  const {
    current: estado,
    actualizar,
    cargarPorId,
    desactivar,
    activar
  } = useEstadosStore((state) => state);

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
  }, [id]);

  const handleSave = (values: ActualizarEstado) => {
    return actualizar(id, values);
  };

  const handleDelete = async () => {
    await desactivar(id);
  };

  const handleActivate = async () => {
    await activar(id);
  };

  return (
    <EstadoForm
      estado={estado}
      onSave={handleSave}
      onDelete={handleDelete}
      onActivate={handleActivate}
    />
  );
};

export default EditarEstado;
